/**
 * @generated SignedSource<<e5dc8190efd14e8012b2b660184e3687>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useRegisterDeviceForPushNotificationsAsyncFragment_memberUser$data = {
  readonly id: string;
  readonly metadata: {
    readonly expoTokens: ReadonlyArray<string | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "useRegisterDeviceForPushNotificationsAsyncFragment_memberUser";
};
export type useRegisterDeviceForPushNotificationsAsyncFragment_memberUser$key = {
  readonly " $data"?: useRegisterDeviceForPushNotificationsAsyncFragment_memberUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRegisterDeviceForPushNotificationsAsyncFragment_memberUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRegisterDeviceForPushNotificationsAsyncFragment_memberUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expoTokens",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberUser",
  "abstractKey": null
};

(node as any).hash = "e7c6be2fa4ae0aff3f9de21087899912";

export default node;
